import { render, staticRenderFns } from "./resetLoginDc.vue?vue&type=template&id=daaf5b28&scoped=true"
import script from "./resetLoginDc.vue?vue&type=script&lang=js"
export * from "./resetLoginDc.vue?vue&type=script&lang=js"
import style0 from "./resetLoginDc.vue?vue&type=style&index=0&id=daaf5b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaf5b28",
  null
  
)

export default component.exports